import React from "react";
import StatsCard from "./StatsCard";
import { useLanguage } from "../../context/LanguageContext";
import { FaStar, FaSun, FaShieldAlt } from "react-icons/fa";

const StatsCardContainer = () => {
  const { t } = useLanguage();

  const statsData = [
    {
      icon: <FaStar />,
      number: "0%",
      description: t("stats.personalIncomeTax"),
      color: "yellow",
    },
    {
      icon: <FaSun />,
      number: "330+",
      description: t("stats.sunnyDays"),
      color: "blue",
    },
    {
      icon: <FaShieldAlt />,
      number: "#1",
      description: t("stats.safestCity"),
      color: "yellow",
    },
  ];

  return (
    <div className="stats-container d-flex flex-row gap-3 justify-content-center align-items-center flex-wrap">
      {statsData.map((stat, index) => (
        <StatsCard
          key={index}
          icon={stat.icon}
          number={stat.number}
          description={stat.description}
          color={stat.color}
        />
      ))}
    </div>
  );
};

export default StatsCardContainer;
